<template>
  <div class="steps">
    <el-steps :active="active">
      <el-step v-for="(option, index) in options" :key="index" :title="option"></el-step>
    </el-steps>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    active: {
      type: Number,
      required: true
    },
    options: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.steps {
  :deep(.el-steps--simple) {
    padding: 0;
  }

  :deep(.el-step__head) {
    display: none;
  }

  :deep(.el-step__title) {
    position: relative;
    width: calc(100% - 12px);
    padding: $spacing-unit * 2 ($spacing-unit * 4 - 12px) $spacing-unit * 2 $spacing-unit * 4;
    font-size: $font-small-size;
    font-weight: 400;
    line-height: $spacing-unit * 2;
    color: $text-color-white;
    text-align: center;
    white-space: nowrap;
    background: $steps-light-color;
    transition: all 0.2s linear;

    &.is-process {
      background: $steps-color;
    }

    &::before,
    &::after {
      position: absolute;
      top: 0;
      display: block;
      width: 0;
      height: 0;
      line-height: 0px;
      content: '';
      border-style: solid;
      border-width: $spacing-unit * 3 0 $spacing-unit * 3 $spacing-unit * 1.5;
      transition: all 0.2s linear;
    }

    &::before {
      left: 0;
      border-color: transparent transparent transparent #fff;
    }

    &::after {
      left: 100%;
      background-color: #fff;
      border-color: transparent transparent transparent $steps-light-color;
    }

    &.is-process::after {
      border-color: transparent transparent transparent $steps-color;
    }
  }

  :deep(.el-step__arrow) {
    display: none;
  }

  :deep(.el-step) {
    width: 100%;
  }

  :deep(.el-step.is-simple:not(:last-of-type) .el-step__title) {
    max-width: 100%;
  }
}
</style>
